module.exports = __webpack_public_path__ + "img/surveying4.3c1a46c6.png";